// TES-1029 — where a patient's evidence files show for the doctor.
//
// A transfer patient hands over her prescription and earlier lab results
// with F-07 (templateKey `prescription_transfer`), before any consult. The
// "Medicinskt underlag" list on the Blodprov tab used to show CP-06 files
// only, and only those from the current case (after the consult was
// documented), so her F-07 files never appeared where the treatment
// decision is made. They are listed apart, with no case cutoff: she sent
// them for this transfer, whenever that was.

export const F07_TEMPLATE_KEY = "prescription_transfer";

export interface EvidenceUploadLike {
  templateKey: string;
  createdAt: string;
}

export function splitEvidenceUploads<T extends EvidenceUploadLike>(
  uploads: readonly T[],
  caseSince: string | null,
): { caseUploads: T[]; transferUploads: T[] } {
  const caseUploads: T[] = [];
  const transferUploads: T[] = [];
  for (const u of uploads) {
    if (u.templateKey === F07_TEMPLATE_KEY) transferUploads.push(u);
    else if (!caseSince || u.createdAt >= caseSince) caseUploads.push(u);
  }
  return { caseUploads, transferUploads };
}

// The heading over a transfer patient's own files, with the count.
export function patientAttachmentsHeading(n: number): string {
  return `Bilagor från patienten (${n})`;
}
